import { motion } from 'framer-motion';
import styled from 'styled-components';

const ScoreWrapper = styled(motion.div)`
  position: fixed;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.95);
  padding: 15px 25px;
  border-radius: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #6B8E23;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  cursor: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ScoreLabel = styled.div`
  font-size: 14px;
  color: #888;
  font-weight: normal;
`;

const ScoreValue = styled.div`
  font-size: 24px;
`;

interface ScoreProps {
  score: number;
  totalScore: number;
}

export const Score = ({ score, totalScore }: ScoreProps) => {
  return (
    <ScoreWrapper
      key={score}
      initial={{ scale: 1 }}
      animate={{ scale: [1, 1.1, 1] }}
      transition={{ duration: 0.3 }}
    >
      <div>
        <ScoreLabel>Esta sessão</ScoreLabel>
        <ScoreValue>{score}</ScoreValue>
      </div>
      <div style={{ borderTop: '1px solid #ddd', paddingTop: '8px', marginTop: '3px' }}>
        <ScoreLabel>Total de sempre</ScoreLabel>
        <ScoreValue>{totalScore}</ScoreValue>
      </div>
    </ScoreWrapper>
  );
};
